{
  "eyebrow": "Choose your plan",
  "title": "Pick the plan that fits the way your team works.",
  "sub": "30-day free trial on every plan. No credit card required. Cancel anytime.",
  "bill": {
    "month": "Monthly",
    "year": "Annual",
    "save": "Save ~17%"
  },
  "fam": {
    "time": "Time & operations",
    "project": "Project & cost control"
  },
  "compare": "Compare all features",
  "compareHide": "Hide comparison",
  "included": "What's included",
  "select": "Select {{plan}}",
  "selected": "Selected",
  "recommended": "Most popular",
  "pricePerMonth": "/ user / month",
  "pricePerYear": "/ user / year",
  "base": "base / month",
  "admins": "2 administrators included",
  "continueCta": "Continue with {{plan}}",
  "continuePick": "Select a plan to continue",
  "catalogError": "Price catalog unavailable. Retry to load the latest pricing.",
  "plans": {
    "timeBasic": "Time Basic",
    "timePro": "Time Pro",
    "projectBasic": "Project Basic",
    "projectPro": "Project Pro",
    "timeBasicBest": "Compliance & simple tracking",
    "timeProBest": "Team operations",
    "projectBasicBest": "Project & cost control",
    "projectProBest": "Advanced project management",
    "feat": {
      "timeBasic": {
        "timeTracking": "Time registration",
        "absencesHolidays": "Absences & holidays",
        "transport": "Transportation logs",
        "workLocations": "Work locations & GPS",
        "mobileApp": "Mobile app for field workers"
      },
      "timePro": {
        "everythingTime": "Everything in Time Basic",
        "overtime": "Overtime tracking",
        "scheduling": "Shift scheduling",
        "documents": "Employee documents",
        "officeOps": "Office operations (activity log, corrections)",
        "addonsAvailable": "Add-ons available: Project tracking, VTT",
        "internalMessaging": "Internal messaging (company chat)"
      },
      "projectBasic": {
        "everythingTime": "Everything in Time Basic",
        "projects": "Projects with cost control",
        "extras": "Extra work & extra material",
        "subcontractors": "Subcontractor management",
        "checkInOut": "Worker check-in / check-out",
        "internalMessaging": "Internal messaging (company chat)"
      },
      "projectPro": {
        "everythingAll": "Everything in Time Pro + Project Basic",
        "projectTransport": "Project-scoped transportation",
        "fullSuite": "Full productivity suite",
        "prioritySupport": "Priority support",
        "internalMessaging": "Internal messaging (company chat)"
      }
    },
    "timeZero": "Time Zero"
  },
  "comparison": {
    "title": "Compare all features",
    "subtitle": "Everything each plan includes, side by side.",
    "cat": {
      "timeAttendance": "Time & attendance",
      "projectCost": "Project & cost control",
      "support": "Support"
    },
    "val": {
      "upTo4": "Up to 4",
      "unlimited": "Unlimited",
      "soon": "Soon",
      "optional": "Optional",
      "years5": "5 years",
      "years10": "10 years"
    },
    "row": {
      "mobileDesktop": "Mobile & desktop app",
      "gpsCheckin": "One-tap check-in with GPS",
      "holidayAbsenceOvertime": "Holiday, absence & overtime",
      "teamMembers": "Team members",
      "workLocations": "Work locations",
      "registrationsPerMonth": "Registrations / user / month",
      "irregularMap": "Irregular clock-in/out on map",
      "expenseManagement": "Expense management",
      "employeeDocuments": "Employee documents",
      "openApi": "Open API",
      "navigation": "Navigation to work sites",
      "projectManagement": "Project management (budget)",
      "subprojects": "Subprojects",
      "subcontractorManagement": "Subcontractor management",
      "extraWorkMaterials": "Extra work & materials",
      "transportProjects": "Transport linked to projects",
      "fullSuite": "Full productivity suite",
      "prioritySupport": "Priority support",
      "schedulingMessaging": "Scheduling & planning · Messaging · Notifications",
      "languages12": "Available in 12 languages",
      "manualTransport": "Manual transport distance",
      "reportsExcel": "Reports & Excel export",
      "frontendLocations": "Locations created by app users",
      "checkInWork": "Check-in/out@work (Belgium)",
      "vehicleTracking": "Vehicle Track & Trace",
      "projectDescriptions": "Project descriptions & pictures",
      "dataStorage": "Data storage"
    }
  }
}
